import { useCallback } from "react";
import { useBusiness } from "@hooks/useBusiness";

export const STORE_ROOT = "store";

/**
 * Builds admin URLs in the form /store/<handle>/<path>, mirroring
 * admin.shopify.com/store/<handle>/orders.
 *
 * Every link and navigate() in the admin area goes through this so the handle
 * is applied in exactly one place.
 */
export function storePath(handle, path = "") {
  const clean = String(path).replace(/^\/+/, "");
  if (!handle) return clean ? `/${clean}` : "/";
  return clean ? `/${STORE_ROOT}/${handle}/${clean}` : `/${STORE_ROOT}/${handle}`;
}

export function useStorePath() {
  const { storeHandle } = useBusiness();

  const build = useCallback((path) => storePath(storeHandle, path), [storeHandle]);

  return { storeHandle, storePath: build };
}

export default useStorePath;
